import BloqueioTipo from "@/Models/Pessoa/Bloqueio/BloqueioTipo";
import { Axios } from "@/Services/Axios";
import RequestUtilitario, { QueryBasicaParam } from "@/Utils/RequisicaoUtilitario";
import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

export function useBloqueioTipoSelect({
    pessoaGenero,
    ativo,
    ...rest
}:QueryBasicaParam<AxiosResponse<BloqueioTipo[]>, BloqueioTipo[], {
    pessoaGenero?:BloqueioTipo,
    ativo?:boolean
}>) {
    const queryString = RequestUtilitario.objectToQueryString({
        ...(pessoaGenero ?? {}),
        ativo
    });

    return useQuery({
        ...rest,
        queryKey : [ "Pessoa.Bloqueio.Tipo.ListarTodos", `Pessoa.Bloqueio.Tipo.ListarTodos?${queryString}` ],
        queryFn : () => Axios.get<BloqueioTipo[]>(`pessoa/bloqueio/tipo?${queryString}`),
        staleTime : 1000 * 60 * 2.5,
        select(data) {
            return data.data;
        },
    });
}